// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js!./trix.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../vue-style-loader/lib/addStylesClient.js")("005843ae", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/trix/dist/trix.css
// module id = 2928
// module chunks = 0